import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20background%20with%20soft%20orange%20red%20and%20warm%20golden%20flowing%20shapes%2C%20cinematic%20atmosphere%2C%20elegant%20luxurious%20theater%20vibe%2C%20minimal%20clean%20composition&width=1920&height=600&seq=qiezi-cta-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-800/90 to-primary-900/80"></div>
      </div>

      <div className="relative z-10 container-main text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">
          准备好开始您的观影之旅了吗？
        </h2>
        <p className="text-white/80 text-sm md:text-base mb-8 max-w-lg mx-auto">
          海量高清视频内容，无需注册即可观看。随时随地，打开茄子视频，精彩即刻开始。
        </p>
        <div className="flex items-center justify-center gap-4">
          <Link
            to="/"
            className="px-8 py-3 bg-white text-primary-700 rounded-full text-sm font-semibold hover:bg-white/90 transition-colors whitespace-nowrap"
          >
            立即观看
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/10 text-white border border-white/30 rounded-full text-sm font-semibold hover:bg-white/20 transition-colors whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}